<template>
  <div class="embed-layout">
    <RouterView />
  </div>
</template>

<style scoped>
.embed-layout {
  min-height: var(--app-viewport-height);
  height: 100%;
  margin: 0;
}
</style>
